import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public API
export const conferenceAPI = {
  getAll: (params) => api.get('/conferences', { params }),
  getById: (id) => api.get(`/conferences/${id}`),
  submit: (formData) => {
    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === 'categories' && Array.isArray(formData[key])) {
        data.append(key, formData[key].join(','));
      } else if (formData[key] !== null && formData[key] !== undefined) {
        data.append(key, formData[key]);
      }
    });
    return api.post('/conferences/submit', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};

export const blogAPI = {
  getAll: () => api.get('/blog'),
  getBySlug: (slug) => api.get(`/blog/${slug}`)
};

export const authAPI = {
  login: (credentials) => api.post('/admin/login', credentials)
};

// Admin API
export const adminAPI = {
  conferences: {
    getAll: () => api.get('/admin/conferences'),
    create: (formData) => {
      return api.post('/admin/conferences', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    },
    update: (id, data) => api.patch(`/admin/conferences/${id}`, data),
    updateWithImage: (id, formData) => api.post(`/admin/conferences/${id}/update`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
    delete: (id) => api.delete(`/admin/conferences/${id}`)
  },
  sheets: {
    export: () => api.post('/admin/sheets/export'),
    import: () => api.post('/admin/sheets/import'),
    sync: () => api.post('/admin/sheets/sync'),
    scrapeImport: (url) => api.post('/admin/sheets/scrape-import', { url }),
    repairImages: () => api.post('/admin/conferences/repair-images')
  },
  blog: {
    getAll: () => api.get('/admin/blog'),
    create: (formData) => {
      return api.post('/admin/blog', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    },
    update: (id, data) => api.patch(`/admin/blog/${id}`, data),
    delete: (id) => api.delete(`/admin/blog/${id}`)
  },
  transactions: {
    getAll: () => api.get('/admin/transactions'),
    syncStripe: () => api.post('/admin/transactions/sync-stripe'),
    toggleExclude: (id, excluded) => api.patch(`/admin/transactions/${id}/exclude`, { excluded })
  },
  messages: {
    getAll: () => api.get('/admin/messages'),
    markRead: (id) => api.patch(`/admin/messages/${id}/read`),
    delete: (id) => api.delete(`/admin/messages/${id}`),
    reply: (id, reply) => api.post(`/admin/messages/${id}/reply`, { reply })
  },
  coupons: {
    getAll: () => api.get('/admin/coupons'),
    create: (data) => api.post('/admin/coupons', data),
    update: (id, data) => api.patch(`/admin/coupons/${id}`, data),
    delete: (id) => api.delete(`/admin/coupons/${id}`)
  },
  stats: {
    get: () => api.get('/admin/stats')
  },
  settings: {
    get: () => api.get('/admin/settings'),
    update: (data) => {
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });
      return api.post('/admin/settings', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
  }
};

export const couponAPI = {
  validate: (code) => api.post('/coupons/validate', { code })
};

export const getImageUrl = (filename) => {
  if (!filename) return '/hero-seo.webp';
  if (filename.startsWith('http')) return filename;
  return `${API}/uploads/${filename}`;
};

export const handleImageError = (e) => {
  e.target.onerror = null;
  e.target.src = '/hero-seo.webp';
};

export default api;